import checkout from "./form";

const {
  formField: {
    certificate,
    fullName,
    firstTime,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxpayerName,
    timeSign,
    checkbox1,
    checkbox2,
  },
} = checkout;

const initialValues = {
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [certificate.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
};

export default initialValues;
